import OriginalJoi from 'joi';
import { JsonPrefix } from './data';

// this custom version is used mainly to validate forms, and should be used with the customResolver

const Joi = OriginalJoi.defaults((schema) => {
  return schema.options({
    abortEarly: false,
    // extract all variables in a json-like string because later we will parse it into a normal json object
    // using JSON.parse, see the customResolver
    // later we will add other variables to it like "label"
    // because we can't get those variables here
    // we should be able to use those variables as i18n context, so we can write some flexible error msgs.

    // we can get the available variables from this files https://github.com/sideway/joi/tree/master/lib/types
    // its included with each file messages at the bottom, there is more than i used here.
    messages: {
      '*': `${JsonPrefix}{
        "value": "{{#value}}", 
        "limit": "{{#limit}}",
        "valids": "{{#valids}}",
        "multiple": "{{#multiple}}",
        "types": "{{#types}}",
        "format": "{{#format}}",
        "ref": "{{#ref}}"
      }`,
    },
  });
});

const RefFn = Joi.ref.bind(Joi);

// override the .ref defaults so the ref is always parsad when used in messages
Joi.ref = (key, options) => {
  return RefFn(key, { render: true, ...options });
};

export default Joi;
